export default __webpack_public_path__ + "static/media/ArrowDown.55715fd3.svg";